import { useRef, useEffect } from 'react'
import abcjs from 'abcjs'

interface MusicStaffProps {
  abc: string
  width?: number
  greenIndices?: Set<number>
  redIndices?: Set<number>
  addClasses?: boolean
}

export default function MusicStaff({ abc, width, greenIndices, redIndices, addClasses }: MusicStaffProps) {
  const containerRef = useRef<HTMLDivElement>(null)
  const hasHighlights = (greenIndices && greenIndices.size > 0) || (redIndices && redIndices.size > 0)

  useEffect(() => {
    if (!containerRef.current) return
    abcjs.renderAbc(containerRef.current, abc, {
      staffwidth: width ?? 200,
      paddingtop: 0,
      paddingbottom: 0,
      paddingleft: 0,
      paddingright: 0,
      responsive: 'resize',
      add_classes: !!hasHighlights || !!addClasses,
    })

    if (hasHighlights) {
      const noteEls = containerRef.current?.querySelectorAll('.abcjs-note') ?? []
      greenIndices?.forEach(idx => {
        if (idx < noteEls.length) {
          noteEls[idx].querySelectorAll('path').forEach(p => {
            (p as SVGElement).style.fill = '#16a34a'
          })
        }
      })
      redIndices?.forEach(idx => {
        if (idx < noteEls.length) {
          noteEls[idx].querySelectorAll('path').forEach(p => {
            (p as SVGElement).style.fill = '#ef4444'
          })
        }
      })
    }
  }, [abc, width, greenIndices, redIndices])

  return <div ref={containerRef} className="flex justify-center" />
}
